(ns common.schema.entities.kpi-report
  (:require [common.schema.schema-utils :as su]
            [common.currencies :as currencies]))

(def granularity-options [{:key   :monthly
                           :label "Monthly"}
                          {:key   :quarterly
                           :label "Quarterly"}])

(def status-options [{:key   :kpi-report.status/draft
                      :label "Not started"}
                     {:key   :kpi-report.status/reviewed
                      :label "Reviewed"}
                     {:key   :kpi-report.status/submitted
                      :label "Submitted"}
                     {:key   :kpi-report.status/wip
                      :label "WIP"}
                     {:key   :kpi-report.status/add
                      :label "Add"}])

(def schema
  (vec (concat (su/boolean-field :kpi-report/forecast-requested? "Include forecast data" {:authorization su/access-user-ssg})
               (su/keyword-field :kpi-report/currency "Report currency" currencies/options {:authorization su/access-user-ssg})
               (su/keyword-field :kpi-report/granularity "Granularity" granularity-options {:authorization su/access-user-ssg})
               (su/keyword-field :kpi-report/kpis "Quantitative " nil {:authorization su/access-user-ssg})
               (su/keyword-field :kpi-report/status "Status" status-options {:authorization su/access-user-ssg})
               (su/keyword-field :kpi-report/questions "Questions " nil {:authorization su/access-user-ssg})
               (su/long-field :kpi-report/target-period "Target period" {:authorization su/access-user-ssg})
               (su/long-field :kpi-report/target-year "Target year" {:authorization su/access-user-ssg})
               (su/datetime-field :kpi-report/activated-on "Activated on" {:authorization su/access-user-ssg})
               (su/datetime-field :kpi-report/reviewed-on "Reviewed on" {:authorization su/access-user-ssg})
               (su/datetime-field :kpi-report/requested-on "Requested on" {:authorization su/access-user-ssg})
               (su/datetime-field :kpi-report/submitted-on "Reviewed on" {:authorization su/access-user-ssg})
               (su/single-ref-field :kpi-report/contact-person "Contact person" [:entity.type/person] {:authorization su/access-user-ssg})
               (su/single-ref-field :kpi-report/contact-account "Contact account" [:entity.type/account] {:authorization su/access-user-ssg})
               (su/single-ref-field :kpi-report/submitted-by "Submitted by" [:entity.type/account] {:authorization su/access-user-ssg})
               (su/single-ref-field :kpi-report/activated-by "Activated by" [:entity.type/account] {:authorization su/access-user-ssg})
               (su/single-ref-field :kpi-report/requested-by "Requested by" [:entity.type/account] {:authorization su/access-user-ssg})
               (su/single-ref-field :kpi-report/reviewed-by "Reviewed by" [:entity.type/account] {:authorization su/access-user-ssg})
               (su/single-ref-field :kpi-report/company "Company" [:entity.type/company] {:authorization su/access-user-ssg})
               (su/single-ref-field :kpi-report/kpi-cycle "Kpi cycle" [:entity.type/kpi-cycle] {:authorization su/access-user-ssg})
               (su/single-ref-field :kpi-report/kpi-report-template "Report template" [:entity.type/kpi-report-template] {:authorization su/access-user-ssg})
               (su/text-simple-field :kpi-report/user-guidances "User guidance" {:authorization su/access-user-ssg})
               (su/text-multiline-field :kpi-report/internal-note "Internal note" {:authorization su/access-user-user})
               (su/text-edn-field :kpi-report/ordering "User guidance" {:authorization su/access-user-ssg}))))
